import React from 'react';
import { Modal, Table, Form, Empty, Input, Button } from 'antd';

export default class BuscarServicioModal extends React.Component {

    render () {
        return (
            <Modal
                title={"Búsqueda de Servicio"}
                visible={this.props.visible}
                style={{ top: 30 }}
                width="800px"
                onCancel={this.props.onCancel}
                footer={[
                    <Button
                        key="send"
                        type="primary"
                        onClick={this.props.onCancel}
                    >
                        Cerrar
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Input.Search
                                placeholder="Búsqueda por nombre"
                                autoComplete="off"
                                onChange={(e) => this.props.onChange(e.target.value)}
                                onSearch={value => this.props.onSearch(value)}
                            />
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => record.id}
                                dataSource={this.props.formValues.dataSource}
                                rowSelection={{
                                    onChange: this.props.onChangeRow,
                                    selectedRowKeys: this.props.formValues.selectedRowKeys,
                                    hideDefaultSelections: false
                                }}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Id',
                                        dataIndex: 'id',
                                        key: 'id'
                                    },
                                    {
                                        title: 'Nombre',
                                        dataIndex: 'nombre',
                                        key: 'nombre'
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}